module.exports = __webpack_public_path__ + "img/19_73.9e503dd2.png";